import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import Stats from 'components/Stats'

import contentImageUrl from '../static/img/project-offices_haywards-heath.jpg'

const stats = [
  {
    label_left: "Lettable area (M²)",
    label_right: "135,000 sqft",
    bars: [
      {
        value: 255,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "50",
    bars: [
      {
        value: 216,
        max: 360
      }
    ]
  },
  {
    label_left: "Site sold for alternative use",
    label_right: "100%",
    bars: [
      {
        value: 100,
        max: 100
      }
    ]
  }
]

class Offices extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--layer-up">
          <div className="layout layout--img-right layout--grey">
            <div className="layout__item">
              <SectionTitle
                align="left"
                intro
                icon="icon-offices.svg"
                title="Offices"
              />
            <p className="copy--bold-x">Haywards Heath</p>
              <p>Land adjoining Haywards Heath Station-having pieced together 9 separate commercial office buildings this circa 2 acre site was able to accommodate up to 135,000 sqft gross of B1 offices in what is the towns prime office pitch. Under permitted development rights this site attracted the interest of residential developers and was sold unconditionally with planning subsequently secured for circa 145 flats and commercial space at ground and part first floors</p>

              <Stats stats={stats} />
            </div>
            <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl})`, backgroundSize: 'cover' }} />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Offices;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Offices.js